/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { FieldDisplayWrapper }  from "cms/fields/layout/field-display-wrapper";
import useOrganization from "hooks/useOrganization";
import dayjs from "dayjs";
import { Fragment } from "react";
import { Logger } from "cms/utils/log/logger";


const DateTimeFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();

    const organization = useOrganization() || {};
    const { values, settings } = field || {};
    const { format } = settings || {};
    const DISPLAY_FORMAT = Config.dates.display.datetime;
    const STORAGE_FORMAT = Config.dates.internalFormats.datetime;
    const dateFormat = format ? format : DISPLAY_FORMAT;

    return (
        <FieldDisplayWrapper>
            {values &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { date, tz = organization.tz } = value || {};
                    const { style, format, options } = settings || {};
                    let dateVal = "";
                    try {
                        const dateInZone = dayjs.tz(date, STORAGE_FORMAT, tz);
                        dateVal = date ? dateInZone.format(dateFormat) : "";
                    } catch (e) {
                        Logger.error(e);
                        return null;
                    }
                    
                    return (
                        <Fragment key={index}>
                            <DisplayTextOnly value={dateVal} style={style} format={format} options={options} />
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
DateTimeFieldDisplay.displayName = "DateTimeFieldDisplay";
export { DateTimeFieldDisplay };
